import { render, staticRenderFns } from "./CustomChipsGroup.vue?vue&type=template&id=29ff2284&scoped=true"
import script from "./CustomChipsGroup.vue?vue&type=script&lang=js"
export * from "./CustomChipsGroup.vue?vue&type=script&lang=js"
import style0 from "./CustomChipsGroup.vue?vue&type=style&index=0&id=29ff2284&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29ff2284",
  null
  
)

export default component.exports